export default __webpack_public_path__ + "static/media/Path 127.82402da6.svg";